import type { AppRequestRoute } from './types'

import { isFullArray } from '@shared/lib/array'

import routes from './routes'

type ParamPrimitive = string | number | boolean
type ParamValue = ParamPrimitive | ParamPrimitive[]

export const useApiRoute = (name: AppRequestRoute, params?: Record<string, ParamValue>): string | null => {
  const { public: { appUrl: baseUrl } } = useRuntimeConfig()
  let path = (routes as Record<string, string>)[name]
  if (!path) return null

  const qs = new URLSearchParams()

  const norm = (v: ParamPrimitive) =>
    typeof v === 'boolean' ? (v ? '1' : '0') : String(v)

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      const placeholder = `[${key}]`

      if (!isFullArray(value) && path.includes(placeholder)) {
        path = path.replace(placeholder, norm(value))
        continue
      }

      if (isFullArray(value)) {
        value.forEach((item, index) => qs.append(`${key}[${index}]`, norm(item)))
      } else {
        qs.append(key, norm(value))
      }
    }
  }

  const query = qs.toString()
  return `${baseUrl}${path}${query ? `?${query}` : ''}`
}
